import { useQuery } from '@tanstack/react-query';
import { valueSetsService } from '../services/value-sets.service';

/**
 * Turns an outcome reason code into words.
 *
 * The codes are stable identifiers the engine writes; the words live in the
 * `notificationOutcomeReason` value set so they can be changed or translated
 * without a release. Falls back to the code itself, so an unfamiliar one is
 * still shown rather than blanked — a reason the reader cannot decode is
 * better than no reason at all.
 */
export const useOutcomeReasonLabel = () => {
  const { data } = useQuery({
    queryKey: ['vs', 'notificationOutcomeReason'],
    queryFn: () => valueSetsService.getByKey('notificationOutcomeReason', 'en'),
    staleTime: 3e5,
  });
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const byCode = new Map<string, string>(((data?.items || []) as any[]).map((i) => [i.code, i.label || i.code]));
  return (code?: string | null): string => (code ? byCode.get(code) || code : '');
};
